module.exports = __webpack_public_path__ + "img/5.182028a9.png";